import React, { useState } from 'react';
import { Mail, Clock } from 'lucide-react';
import { API_BASE } from '../lib/apiBase';
import IconBadge from './IconBadge';
import './Contact.css';

function Contact() {
    const [formData, setFormData] = useState({
        name: '',
        email: '',
        phone: '',
        service: '',
        message: ''
    });
    const [result, setResult] = useState('');
    const [isSubmitting, setIsSubmitting] = useState(false);

    const handleChange = (e) => {
        setFormData({
            ...formData,
            [e.target.name]: e.target.value
        });
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setIsSubmitting(true);
        setResult('');

        try {
            const response = await fetch(`${API_BASE}/api/contact`, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify(formData),
            });
            const json = await response.json();
            if (json.success) {
                setResult('success');
                setFormData({ name: '', email: '', phone: '', service: '', message: '' });
            } else {
                setResult('error');
            }
        } catch {
            setResult('error');
        } finally {
            setIsSubmitting(false);
        }
    };

    return (
        <section id="contact" className="section section-alt">
            <div className="container">
                <div className="section-header text-center">
                    <h2 className="section-title">Contact Us</h2>
                    <p className="section-subtitle">
                        We are available to respond to all inquiries and requests from 9:00 AM - 3:00 PM CST Monday - Friday (Except on public holidays)
                    </p>
                </div>
                <div className="contact-content">
                    <div className="contact-info">
                        <h3 className="contact-info-title">Contact Information</h3>
                        <div className="contact-item">
                            <IconBadge icon={Mail} variant="teal" size="sm" />
                            <div className="contact-details">
                                <div className="contact-label">Email</div>
                                <a href="mailto:clientservices@guzmancareerservices.com" className="contact-value">
                                    clientservices@guzmancareerservices.com
                                </a>
                            </div>
                        </div>
                        <div className="contact-item">
                            <IconBadge icon={Clock} variant="teal" size="sm" />
                            <div className="contact-details">
                                <div className="contact-label">Business Hours</div>
                                <div className="contact-value">
                                    Monday - Friday: 9:00 AM - 3:00 PM CST<br />
                                    (Except on public holidays)
                                </div>
                            </div>
                        </div>
                    </div>
                    <form className="contact-form" onSubmit={handleSubmit}>
                        <div className="form-group">
                            <label htmlFor="name">Full Name *</label>
                            <input
                                type="text"
                                id="name"
                                name="name"
                                value={formData.name}
                                onChange={handleChange}
                                required
                                placeholder="John Doe"
                            />
                        </div>
                        <div className="form-group">
                            <label htmlFor="email">Email Address *</label>
                            <input
                                type="email"
                                id="email"
                                name="email"
                                value={formData.email}
                                onChange={handleChange}
                                required
                                placeholder="john@example.com"
                            />
                        </div>
                        <div className="form-group">
                            <label htmlFor="phone">Phone Number</label>
                            <input
                                type="tel"
                                id="phone"
                                name="phone"
                                value={formData.phone}
                                onChange={handleChange}
                                placeholder="+1 (555) 123-4567"
                            />
                        </div>
                        <div className="form-group">
                            <label htmlFor="service">Service of Interest *</label>
                            <select
                                id="service"
                                name="service"
                                value={formData.service}
                                onChange={handleChange}
                                required
                            >
                                <option value="">Select an option</option>
                                <option value="consultation">New Client — Free Consultation</option>
                                <option value="existing-client">Existing Client Support</option>
                                <option value="general">General Inquiry</option>
                            </select>
                        </div>
                        <div className="form-group">
                            <label htmlFor="message">Message *</label>
                            <textarea
                                id="message"
                                name="message"
                                value={formData.message}
                                onChange={handleChange}
                                required
                                rows="5"
                                placeholder="Tell us about your career goals and how we can help..."
                            ></textarea>
                        </div>
                        <button type="submit" className="btn btn-primary btn-lg form-submit" disabled={isSubmitting}>
                            {isSubmitting ? 'Sending...' : 'Send Message'}
                        </button>
                        {result === 'success' && (
                            <p className="form-result form-result--success">
                                Thank you! We will get back to you shortly.
                            </p>
                        )}
                        {result === 'error' && (
                            <p className="form-result form-result--error">
                                Something went wrong. Please try again or email us directly.
                            </p>
                        )}
                    </form>
                </div>
            </div>
        </section>
    );
}

export default Contact;
